var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 73,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.778 24.404v-1.273h7.22v1.273h-2.935V36.23H48.72V24.404h-2.943ZM54.885 23.13h1.324v11.834h5.055v1.265h-6.38V23.13ZM63.357 23.13h7.542v1.292h-6.227v4.096h6.173V29.8h-6.173v5.138h6.173v1.29h-7.488V23.132ZM46.484 53.825l1.87-13.099h.215l5.35 10.748 5.296-10.747h.215l1.887 13.098H60.02l-1.288-9.368-4.652 9.367h-.331l-4.715-9.438-1.28 9.438h-1.27ZM63.93 40.727h7.541v1.29h-6.226v4.096h6.173v1.283h-6.173v5.137h6.173v1.291H63.93V40.727ZM86 43.157l-1.038.793a5.615 5.615 0 0 0-2.066-1.683c-.8-.386-1.68-.579-2.64-.579-1.05 0-2.021.252-2.916.757a5.405 5.405 0 0 0-2.084 2.021c-.49.843-.734 1.793-.734 2.85 0 1.596.549 2.929 1.646 3.997 1.103 1.069 2.493 1.603 4.169 1.603 1.843 0 3.385-.718 4.625-2.154l1.038.783a6.66 6.66 0 0 1-2.46 1.932c-.978.451-2.073.677-3.284.677-2.302 0-4.118-.763-5.448-2.288-1.115-1.289-1.673-2.844-1.673-4.666 0-1.918.674-3.53 2.022-4.835 1.354-1.312 3.048-1.968 5.082-1.968 1.228 0 2.338.243 3.328.73A6.414 6.414 0 0 1 86 43.157ZM10.681 39.082l-7.15-1.691v3.384l7.15-1.693Z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.944 59.74-.325-.2c-.06.069-.123.134-.186.2a30.473 30.473 0 0 1-22.356 9.7 30.572 30.572 0 0 1-21.568-8.89 30.296 30.296 0 0 1-8.888-23.136 30.157 30.157 0 0 1 9.082-19.987A30.437 30.437 0 0 1 32.401 8.77c.556-.03 1.115-.045 1.676-.046.562-.002 1.12.014 1.676.046a30.465 30.465 0 0 1 20.622 9.596h4.688A34.083 34.083 0 0 0 43.901 6.602a34.233 34.233 0 0 0-20.834.38A34.066 34.066 0 0 0 6.35 19.364 33.81 33.81 0 0 0 0 39.117a33.81 33.81 0 0 0 6.392 19.74 34.067 34.067 0 0 0 16.743 12.347 34.233 34.233 0 0 0 20.836.336 34.082 34.082 0 0 0 17.137-11.8h-4.164Z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m34.082 15.79 1.701-7.12h-3.4l1.699 7.12ZM34.082 62.376l1.701 7.12h-3.4l1.699-7.12ZM14.585 20.458l-2.404-3.883-1.5 1.49 3.905 2.393ZM56.433 59.74c.063-.066.125-.131.186-.2l.325.2.49.299-1.488 1.492-.486-.783.973-1.007Z",
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.812 0H28.353a.757.757 0 0 0-.759.755v1.509c0 .417.34.755.76.755h11.458c.42 0 .76-.338.76-.755V.755a.757.757 0 0 0-.76-.755Z",
    fill: "url(#a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.434 57.798 12.03 61.68l-1.5-1.49 3.905-2.393Z",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.067 38.116v-8.432c.56-.68.931-.818 1.741-.693l15.203 9.125v14.438l-3.598 2.195v-8.663l-13.345-7.97Z",
    fill: "url(#b)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.102 28.57v-8.43c.56-.681.93-.82 1.74-.694l15.203 9.125v20.402l-3.597 2.195V36.54l-13.346-7.97Z",
    fill: "url(#c)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m30.512 47.472-16.595-9.703v9.587l16.595 10.165V47.47Z",
    fill: "url(#d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.002,
    y1: 36.518,
    x2: 85.988,
    y2: 36.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "teal"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BAAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.002,
    y1: 36.518,
    x2: 85.988,
    y2: 36.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "teal"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BAAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.002,
    y1: 36.518,
    x2: 85.988,
    y2: 36.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "teal"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BAAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.002,
    y1: 36.518,
    x2: 85.988,
    y2: 36.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "teal"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BAAAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7ebf12feaa5891443dfc07e6a501ef35.svg";
export { ForwardRef as ReactComponent };